import React from "react";

function Btn100({ text, radius, disabled, secondary, additionalClass, onClick}) {

  return (
    <button
      className={`btn100 ${radius ? "radius" : ""} ${disabled ? "disabled" : ""} ${secondary ? "secondary" : ""} ${additionalClass}`}
      onClick={onClick}
    >
      {text}
    </button>
  );
}

export default Btn100;
